import React, { ChangeEvent, useContext, useState } from "react";

import { Box, makeStyles, Tab, Tabs } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";

import HospitalInfoTable from "./HospitalInfoTable";
import NursesTable from "./NursesTable";
import { HospitalsContext } from "../RodaHomepage";
import NoData from "../../../components/NoData";
import StatisticsTable from "./StatisticsTable";
import SurveyTable from "./SurveyTable";
import NurseGallery from "../../NurseHomepage/components/NurseGallery/NurseGallery";

const useStyles = makeStyles((theme: Theme) => ({
  indicator: {
    height: 0,
  },
  notSelected: {
    backgroundColor: theme.palette.secondary.light,
    borderTopRightRadius: 4,
    borderTopLeftRadius: 4,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    marginLeft: theme.spacing(2.1),
    marginBottom: 0,
    fontSize: 13,
    fontWeight: "bold",
    textTransform: "uppercase",
    color: theme.palette.primary.main,
    [theme.breakpoints.only("xs")]: {
      fontSize: 12,
    },
  },
  border: {
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("md")]: {
      borderWidth: "initial",
    },
  },
}));

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default function RodaTabs() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const { currentHospital, error } = useContext(HospitalsContext);

  const handleChange = (event: ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <Tabs
        value={value}
        onChange={handleChange}
        classes={{
          indicator: classes.indicator,
        }}
        className={classes.border}
        variant="scrollable"
        scrollButtons="on"
      >
        <Tab label="Podaci o ustanovi" className={classes.notSelected} />
        <Tab label="Zdravstveni djelatnici" className={classes.notSelected} />
        <Tab label="Statistika" className={classes.notSelected} />
        <Tab label="Anketa" className={classes.notSelected} />
        <Tab label="Galerija" className={classes.notSelected} />
      </Tabs>
      <TabPanel value={value} index={0}>
        {!currentHospital && (
          <NoData>
            Nema podataka.
            <br /> Molimo vas da odaberete ustanovu iz
            <br /> padajućeg izbornika na vrhu stranice.
          </NoData>
        )}
        {!!currentHospital && <HospitalInfoTable />}
        {error && (
          <NoData>Trenutno nema podataka o odabranoj ustanovi.</NoData>
        )}
      </TabPanel>
      <TabPanel value={value} index={1}>
        {!currentHospital && (
          <NoData>
            Nema podataka.
            <br /> Molimo vas da odaberete ustanovu iz
            <br /> padajućeg izbornika na vrhu stranice.
          </NoData>
        )}
        {!!currentHospital && <NursesTable />}
      </TabPanel>
      <TabPanel value={value} index={2}>
        {!currentHospital && (
          <NoData>
            Nema podataka.
            <br /> Molimo vas da odaberete ustanovu iz
            <br /> padajućeg izbornika na vrhu stranice.
          </NoData>
        )}
        {!!currentHospital && <StatisticsTable />}
      </TabPanel>
      <TabPanel value={value} index={3}>
        {!currentHospital && (
          <NoData>
            Nema podataka.
            <br /> Molimo vas da odaberete ustanovu iz
            <br /> padajućeg izbornika na vrhu stranice.
          </NoData>
        )}
        {!!currentHospital && <SurveyTable />}
      </TabPanel>
      <TabPanel value={value} index={4}>
        {!currentHospital && (
          <NoData>
            Nema podataka.
            <br /> Molimo vas da odaberete ustanovu iz
            <br /> padajućeg izbornika na vrhu stranice.
          </NoData>
        )}
        {!!currentHospital && (
          <NurseGallery hospitalId={currentHospital} />
        )}
      </TabPanel>
    </>
  );
}
